// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: var(--bg-primary);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border-primary);
  box-shadow: 0 2px 20px var(--shadow-primary);
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--text-primary);
  font-weight: 600;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.logo:hover {
  color: var(--accent-primary);
  transform: translateY(-1px);
}

.logo-img {
  width: 36px;
  height: 36px;
  margin-right: 8px;
  border-radius: 8px;
  object-fit: contain;
}

.logo-text {
  font-family: 'Inter', sans-serif;
  font-weight: 700;
}

.nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav-link {
  text-decoration: none;
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 0.95rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover {
  color: var(--accent-primary);
  background: rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.nav-link.active {
  color: var(--accent-primary);
  background: rgba(59, 130, 246, 0.1);
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 2px;
  background: #2563eb;
  border-radius: 1px;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  gap: 4px;
}

.menu-toggle span {
  width: 25px;
  height: 3px;
  background: var(--text-primary);
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Mobile Menu Styles */
.mobile-menu {
  background: var(--bg-primary);
  backdrop-filter: blur(10px);
  border-top: 1px solid var(--border-primary);
  box-shadow: 0 4px 20px var(--shadow-primary);
  overflow: hidden;
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  background: var(--bg-primary);
}

.mobile-nav-link {
  display: block;
  padding: 1rem 2rem;
  text-decoration: none;
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
  background: var(--bg-primary);
}

.mobile-nav-link:hover {
  color: var(--accent-primary);
  background: var(--bg-secondary);
  border-left-color: var(--accent-primary);
}

.mobile-nav-link.active {
  color: var(--accent-primary);
  background: var(--bg-secondary);
  border-left-color: var(--accent-primary);
}

/* Hamburger Animation */
.menu-toggle.active span:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.menu-toggle.active span:nth-child(2) {
  opacity: 0;
}

.menu-toggle.active span:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

/* Instagram link */
.instagram-link {
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
}

.instagram-link:hover {
  transform: scale(1.1);
}

.instagram-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 1rem;
  }
  
  .nav {
    display: none;
  }
  
  .header-actions {
    gap: 0.5rem;
  }
  
  .menu-toggle {
    display: flex;
  }
  
  .logo-text {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .header-container {
    padding: 0 0.75rem;
  }
  
  .logo-text {
    font-size: 0.9rem;
  }
  
  .logo-img {
    width: 32px;
    height: 32px;
  }
  
  .mobile-nav-link {
    padding: 0.875rem 1.5rem;
    font-size: 0.95rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,2BAA2B;EAC3B,8CAA8C;EAC9C,4CAA4C;EAC5C,oFAAoF;AACtF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,2CAA2C;EAC3C,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA,wBAAwB;AACxB;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;AACF","sourcesContent":[".header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: var(--bg-primary);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--border-primary);\n  box-shadow: 0 2px 20px var(--shadow-primary);\n  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.header-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 70px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: var(--text-primary);\n  font-weight: 600;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n}\n\n.logo:hover {\n  color: var(--accent-primary);\n  transform: translateY(-1px);\n}\n\n.logo-img {\n  width: 36px;\n  height: 36px;\n  margin-right: 8px;\n  border-radius: 8px;\n  object-fit: contain;\n}\n\n.logo-text {\n  font-family: 'Inter', sans-serif;\n  font-weight: 700;\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.nav-link {\n  text-decoration: none;\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-size: 0.95rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.nav-link:hover {\n  color: var(--accent-primary);\n  background: rgba(59, 130, 246, 0.1);\n  transform: translateY(-1px);\n}\n\n.nav-link.active {\n  color: var(--accent-primary);\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.nav-link.active::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 20px;\n  height: 2px;\n  background: #2563eb;\n  border-radius: 1px;\n}\n\n.menu-toggle {\n  display: none;\n  flex-direction: column;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  gap: 4px;\n}\n\n.menu-toggle span {\n  width: 25px;\n  height: 3px;\n  background: var(--text-primary);\n  border-radius: 2px;\n  transition: all 0.3s ease;\n}\n\n/* Mobile Menu Styles */\n.mobile-menu {\n  background: var(--bg-primary);\n  backdrop-filter: blur(10px);\n  border-top: 1px solid var(--border-primary);\n  box-shadow: 0 4px 20px var(--shadow-primary);\n  overflow: hidden;\n}\n\n.mobile-nav {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem 0;\n  background: var(--bg-primary);\n}\n\n.mobile-nav-link {\n  display: block;\n  padding: 1rem 2rem;\n  text-decoration: none;\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  border-left: 3px solid transparent;\n  background: var(--bg-primary);\n}\n\n.mobile-nav-link:hover {\n  color: var(--accent-primary);\n  background: var(--bg-secondary);\n  border-left-color: var(--accent-primary);\n}\n\n.mobile-nav-link.active {\n  color: var(--accent-primary);\n  background: var(--bg-secondary);\n  border-left-color: var(--accent-primary);\n}\n\n/* Hamburger Animation */\n.menu-toggle.active span:nth-child(1) {\n  transform: rotate(45deg) translate(6px, 6px);\n}\n\n.menu-toggle.active span:nth-child(2) {\n  opacity: 0;\n}\n\n.menu-toggle.active span:nth-child(3) {\n  transform: rotate(-45deg) translate(6px, -6px);\n}\n\n/* Instagram link */\n.instagram-link {\n  display: flex;\n  align-items: center;\n  transition: transform 0.2s ease;\n}\n\n.instagram-link:hover {\n  transform: scale(1.1);\n}\n\n.instagram-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  object-fit: contain;\n}\n\n@media (max-width: 768px) {\n  .header-container {\n    padding: 0 1rem;\n  }\n  \n  .nav {\n    display: none;\n  }\n  \n  .header-actions {\n    gap: 0.5rem;\n  }\n  \n  .menu-toggle {\n    display: flex;\n  }\n  \n  .logo-text {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-container {\n    padding: 0 0.75rem;\n  }\n  \n  .logo-text {\n    font-size: 0.9rem;\n  }\n  \n  .logo-img {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .mobile-nav-link {\n    padding: 0.875rem 1.5rem;\n    font-size: 0.95rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
